export default __webpack_public_path__ + "static/media/DeveloperAccess_domain_account_image_3.b9457c30.png";